import { DEFAULT_LOCALE, normalizeLocale } from '@/i18n';
import { getQueryParam } from './getUrlParam';

type ApiLocaleParams = {
  language: string;
  region?: string;
};

const REGION_ALIAS_MAP: Record<string, string> = {
  cn: 'CN',
  china: 'CN',
  'china-mainland': 'CN',
  prc: 'CN',
  'zh-cn': 'CN',
  hk: 'HK',
  hongkong: 'HK',
  'hong-kong': 'HK',
  'zh-hk': 'HK',
  tw: 'TW',
  taiwan: 'TW',
  taipei: 'TW',
  'zh-tw': 'TW',
  us: 'US',
  usa: 'US',
  'united-states': 'US',
  america: 'US',
  uk: 'GB',
  'united-kingdom': 'GB',
  gb: 'GB',
  'great-britain': 'GB',
  jp: 'JP',
  japan: 'JP',
  kr: 'KR',
  korea: 'KR',
  'south-korea': 'KR',
  de: 'DE',
  germany: 'DE',
  fr: 'FR',
  france: 'FR',
  es: 'ES',
  spain: 'ES',
  it: 'IT',
  italy: 'IT',
  in: 'IN',
  india: 'IN',
  sg: 'SG',
  singapore: 'SG',
  my: 'MY',
  malaysia: 'MY',
  id: 'ID',
  indonesia: 'ID',
  th: 'TH',
  thailand: 'TH',
  vn: 'VN',
  vietnam: 'VN',
};

const normalizeToken = (value?: string | null): string => {
  const decoded = decodeURIComponent(value || '')
    .trim()
    .toLowerCase();
  return decoded.replace(/_/g, '-');
};

export const normalizeApiLanguage = (value?: string | null): string => {
  return normalizeLocale(value || DEFAULT_LOCALE);
};

export const normalizeApiRegion = (value?: string | null): string => {
  const normalized = normalizeToken(value);
  if (!normalized) return '';
  return REGION_ALIAS_MAP[normalized] || '';
};

/** 供所有接口自动附带的语言、地区（无合法 region 时不带 region） */
export function getApiLanguageRegionParams(): ApiLocaleParams {
  const urlLanguage = getQueryParam('language') || getQueryParam('locale');
  const urlRegion = getQueryParam('region');
  const language = normalizeApiLanguage(urlLanguage);
  const region = normalizeApiRegion(urlRegion);

  if (!region) {
    return { language };
  }

  return { language, region };
}
